// Business days left in a period, counting `now`'s own day when it is a
// business day - the day is still being worked. A business day is
// Monday-Friday and not a company holiday.
import moment from 'moment';

// Company holidays: New Year's Day, Memorial Day, Independence Day, Labor
// Day, Thanksgiving and Christmas Day. Computed by rule, so there is no list
// to keep up to date each year.

function nthWeekdayOfMonth(year, month, weekday, n) {
  const first = new Date(year, month, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, month, 1 + offset + (n - 1) * 7);
}

function lastWeekdayOfMonth(year, month, weekday) {
  const last = new Date(year, month + 1, 0);
  const offset = (last.getDay() - weekday + 7) % 7;
  return new Date(year, month, last.getDate() - offset);
}

// A fixed-date holiday on a Saturday is observed the Friday before, on a
// Sunday the Monday after (the federal rule).
function observed(year, month, day) {
  const date = new Date(year, month, day);
  if (date.getDay() === 6) {
    return new Date(year, month, day - 1);
  }
  if (date.getDay() === 0) {
    return new Date(year, month, day + 1);
  }
  return date;
}

export function companyHolidays(year) {
  return [
    observed(year, 0, 1),                 // New Year's Day
    lastWeekdayOfMonth(year, 4, 1),       // Memorial Day: last Monday of May
    observed(year, 6, 4),                 // Independence Day
    nthWeekdayOfMonth(year, 8, 1, 1),     // Labor Day: first Monday of September
    nthWeekdayOfMonth(year, 10, 4, 4),    // Thanksgiving: fourth Thursday of November
    observed(year, 11, 25)                // Christmas Day
  ];
}

function dateKey(date) {
  return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
}

export function isCompanyHoliday(date) {
  const key = dateKey(date);
  const year = date.getFullYear();
  // Next year's list too: New Year's Day on a Saturday is observed on 31 December.
  return companyHolidays(year).concat(companyHolidays(year + 1))
    .some(holiday => dateKey(holiday) === key);
}

export function isBusinessDay(date) {
  const weekday = date.getDay();
  return weekday !== 0 && weekday !== 6 && !isCompanyHoliday(date);
}

export function businessDaysLeft(unit, now) {
  const day = moment(now).startOf('day');
  const end = moment(now).endOf(unit);
  let count = 0;
  while (day.isSameOrBefore(end)) {
    if (isBusinessDay(day.toDate())) {
      count++;
    }
    day.add(1, 'day');
  }
  return count;
}

export function describeBusinessDaysLeft(unit, now) {
  const count = businessDaysLeft(unit, now);
  if (count === 1) {
    return 'There is 1 day left in the ' + unit;
  }
  return 'There are ' + count + ' days left in the ' + unit;
}



// WEBPACK FOOTER //
// ./src/utils/businessDays.js